export enum MealType {
  NO_MEAL = "NO_MEAL",
  REGULAR = "REGULAR",
  CASH = "CASH",
}
